import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { QueryClient, QueryClientProvider, useQuery } from "react-query";
import AJXLoader from "@components/AJXLoader";
import LoadError from "@components/LoadError";
import { apiSend, getRoute } from "@services/axios";
import { useParams } from "react-router-dom";

import GeneralInfo from "./components/GeneralInfo";
import ManageHeader from "@components/ManageHeader";

import ITabs from "@components/ITabs";
const queryClient = new QueryClient();

const LoadInformations = (props) => {
  const { isLoading, error, data } = useQuery("repoData", () =>
    apiSend([getRoute("PRODUCT_RETRIEVE"), props.id, "all"].join("/"), "get")
  );
  if (isLoading) return <AJXLoader />;
  if (error) return <LoadError message={props.t("not_found")} />;
  if (data?.data?.request?.status !== true) {
    return <LoadError message={props.t("not_found")} />;
  }
  const product = data?.data?.result;
  props.setProductData(product);

  const toggleEdit = (key) =>
    props.setEditing((prev) => ({ ...prev, [key]: !prev[key] }));

  const onSaved = async (section) => {
    props.setDataEditing(section);
    toggleEdit(section);
    const response = await apiSend(
      [getRoute("PRODUCT_RETRIEVE"), props.id, "all"].join("/"),
      "get"
    );

    props.setProductData(response?.data?.result);
  };

  const tabs = [
    {
      value: "general",
      title: props.t("general"),
      icon: "info",
      component: (
        <GeneralInfo
          editing={props.editing}
          product={props.productData}
          onSaveSuccess={onSaved}
        />
      ),
    },
  ];

  return (
    <sestion>
      <ManageHeader
        title={props.t("Administration")}
        content={props.t("admin_caption")}
      />
      <div className="bg-white">
        {props.productData?.id > 0 ? (
          <ITabs
            navItems={tabs}
            container={"information-product"}
            selected={0}
          />
        ) : (
          <>loading....</>
        )}
      </div>
    </sestion>
  );
};
const Informations = (props) => {
  const [editing, setEditing] = useState({});
  const [dataEditing, setDataEditing] = useState({});
  const [productData, setProductData] = useState({});
  const { t } = useTranslation();
  const id = useParams().id;
  return (
    <QueryClientProvider client={queryClient}>
      <LoadInformations
        t={t}
        editing={editing}
        dataEditing={dataEditing}
        setDataEditing={setDataEditing}
        setEditing={setEditing}
        id={id}
        productData={productData}
        setProductData={setProductData}
        {...props}
      />
    </QueryClientProvider>
  );
};

export default Informations;
